import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Button
} from '@chakra-ui/react'
import React, { useRef } from 'react'

import { IDeleteModalProps } from '../../../../interfaces/KnowledgeArea/KnowledgeArea'

export default function KnowledgeAreaDeleteModal({
  isOpen,
  onClose,
  onDelete,
  leastDestructiveRef,
  itemName = 'item'
}: IDeleteModalProps) {
  const cancelRef = leastDestructiveRef || useRef<HTMLButtonElement>(null)

  return (
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Confirmar exclusão
          </AlertDialogHeader>

          <AlertDialogBody>
            Tem certeza que deseja excluir <strong>{itemName}</strong>? Esta ação não pode ser desfeita.
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button ref={cancelRef} onClick={onClose}>
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={onDelete} ml={3}>
              Excluir
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
